<div class="page">
  <h1 class="title">{{ "general.kits" | translate }}</h1>
  <div fxLayout="column">
    <mat-form-field class="filter">
      <mat-label>{{ "general.filter" | translate }}</mat-label>
      <input matInput [formControl]="filter" #input>
    </mat-form-field>

    <div class="kits-container">
      <table mat-table [dataSource]="dataSource">
        @for (column of ['description', 'itemsQuantity', 'action']; track column) {
          <ng-container [matColumnDef]="column">
            @if (column === 'description') {
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 35%;">
                {{ 'general.description' | translate }}
              </th>
              <td mat-cell *matCellDef="let kit"> {{ kit.description }} </td>
            }
            @if (column === 'itemsQuantity') {
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 40%;">
                {{ 'general.itemsQuantity' | translate }}
              </th>
              <td mat-cell *matCellDef="let kit"> {{ kit.items?.length }} </td>
            }
            @if (column === 'action') {
              <th mat-header-cell *matHeaderCellDef class="table-header action" style="width: 10%;">
                {{ 'general.action' | translate }}
              </th>
              <td mat-cell *matCellDef="let kit" class="action">
                <button mat-icon-button class="custom-red" (click)="deleteKit(kit)">
                  <mat-icon matTooltip="{{'button.delete-tooltip' | translate}}" style="color: #B41E2A;">
                    delete
                  </mat-icon>
                </button>
                <button mat-icon-button (click)="updateKit(kit.id)">
                  <mat-icon matTooltip="{{'button.edit-tooltip' | translate}}">
                    edit
                  </mat-icon>
                </button>
              </td>
            }
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="pageable.length"
      [pageSize]="pageable.pageSize"
      (page)="pageChange($event)"
      [pageSizeOptions]="[5, 10, 20]"
      [pageSize]="5"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
